<div class="auth-page bg-auth">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-7 col-xl-5 my-5">

        <div class="text-center mb-4">
          <span class="brand-badge">🎫</span>
        </div>
        <h1 class="display-4 text-center mb-3">Solicitar acesso</h1>
        <p class="text-muted text-center mb-5">
          Registe a sua empresa. Um administrador analisa o pedido e liberta o acesso.
        </p>

        @if (submitted()) {
          <div class="card">
            <div class="card-body text-center py-6">
              <span class="h1 fe fe-check-circle text-success d-block mb-3"></span>
              <h3 class="mb-2">Pedido enviado</h3>
              <!-- Não prometemos e-mail automático: hoje o convite é entregue pela equipa que
                   aprova o pedido. Dizer "receberá um e-mail" era uma promessa que ninguém cumpria. -->
              <p class="text-muted mb-0">
                Vamos analisar o pedido e contactar
                <strong>{{ form.controls.email.value || 'o endereço indicado' }}</strong>
                com o link que ativa o acesso.
              </p>
            </div>
          </div>
        } @else {
          <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="form-group">
              <label class="form-label">Empresa</label>
              <input class="form-control" formControlName="companyName" placeholder="Nome da empresa" />
              @if (form.controls.companyName.touched && form.controls.companyName.invalid) {
                <small class="text-danger">O nome da empresa é obrigatório.</small>
              }
            </div>

            <div class="form-group">
              <label class="form-label">O seu nome</label>
              <input class="form-control" formControlName="contactName" placeholder="Nome do contacto" />
              @if (form.controls.contactName.touched && form.controls.contactName.invalid) {
                <small class="text-danger">O nome do contacto é obrigatório.</small>
              }
            </div>

            <div class="form-group">
              <label class="form-label">E-mail</label>
              <input class="form-control" type="email" formControlName="email" placeholder="voce@empresa.com" />
              @if (form.controls.email.touched && form.controls.email.invalid) {
                <small class="text-danger">Indique um e-mail válido.</small>
              }
            </div>

            <div class="form-group">
              <label class="form-label">Telefone <span class="text-muted small">(opcional)</span></label>
              <input class="form-control" formControlName="phone" placeholder="912 345 678" />
            </div>

            <div class="form-group">
              <label class="form-label">Mensagem <span class="text-muted small">(opcional)</span></label>
              <textarea class="form-control" formControlName="message" rows="2"></textarea>
            </div>

            @if (serverError()) {
              <div class="alert alert-danger">{{ serverError() }}</div>
            }

            <button class="btn btn-lg w-100 btn-primary mb-3" [disabled]="loading()">
              {{ loading() ? 'Enviando…' : 'Enviar solicitação' }}
            </button>
          </form>
        }
      </div>
    </div>
  </div>
</div>
